import type { TCart } from "@up/data";

type Props = {
  guardian?: TCart["guardian"];
};

const bullet = "md:before:content-['•'] before:text-gray-400 md:before:mr-3";

export default function GuardianInformationDisplay({ guardian }: Props) {
  if (guardian?.firstName || guardian?.lastName || guardian?.email) {
    return (
      <div className="bg-gray-100 p-4 rounded">
        <p className="flex flex-col md:flex-row gap-3 md:items-center leading-none font-bold">
          <span>
            {guardian.firstName} {guardian.lastName}
          </span>
          {guardian.email ? (
            <span className={bullet}>{guardian.email}</span>
          ) : null}
        </p>
      </div>
    );
  }

  return null;
}
